// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1J78D","subheader":"ReorderModal_subheader__nl-H2","listWrap":"ReorderModal_listWrap__3NFJB"};